import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, NavigationError, ActivatedRoute, NavigationCancel, Params } from '@angular/router';
import { EkycOtpRequest, EKycBasicData, GenerateOtpDetails } from 'src/app/home/home.model';
import { HomeService } from 'src/app/home/home.service';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { CommonService } from 'src/app/common/services/common.service';
import { Globals } from 'src/app/globals';

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  isLoading: boolean = false;
  public showValidationMsgs: boolean;
  public request: EkycOtpRequest; 
  public otpResponse: GenerateOtpDetails;
  public validateResponseModel: EKycBasicData;
  public customerId: any;
  loadingText: string;
  timeout1: NodeJS.Timer;
  timeout2: NodeJS.Timer;
  generatedToken: any;
  token: any;
  isShowOtp: boolean = false;
  isShowResendOtp: boolean = false;
  otpErrorMsg: string = "";
  otp: any;
  isKycFailed: boolean = false;
  @ViewChild("validateCustomerForm") validateCustomerForm: any;
    
  constructor(private route: ActivatedRoute, public router: Router,public globals: Globals,private homeService: HomeService, private commonService: CommonService) {
    this.request = new EkycOtpRequest();
    this.otpResponse = new GenerateOtpDetails();
    this.validateResponseModel = new EKycBasicData();
  }
        
  ngOnInit() {
    this.route.queryParams.subscribe(
      (params: Params) => {
        this.token = params["token"];
        if(this.token == null || this.token == '' || this.token == undefined) {
          this.router.navigate(['/Error'], { queryParams: { 'errMsg': 'Invalid Token' } });
        } else {
          this.fetchCustomerInfo();
        }
      }
    );
  }

  fetchCustomerInfo() {
    this.isLoading = true;
    let body = {
      "token": this.token
    }
    this.commonService.validateTokenDetails(body).subscribe(result => {
      this.isLoading= false;
      this.validateResponseModel = JSON.parse(JSON.stringify(result));
      if(this.validateResponseModel.errMsg == '' || this.validateResponseModel.errMsg == null || this.validateResponseModel.errMsg == undefined) {
        this.request.customerName = this.validateResponseModel.customerName;
        this.request.mobileNo = this.validateResponseModel.mobileNo;
        this.request.token = this.validateResponseModel.token;
      } else {
        this.isKycFailed = true;
      }
    });
  }

  Submit(validateCustomerForm: NgForm, isValid) {
      if (!isValid) {
        this.showValidationMsgs = true;
        this.validateAllFields(this.validateCustomerForm.form);
      } else {
        this.generateOtp();
      }
  }

  generateOtp() {
    this.isLoading= true;
    this.homeService.generateOtp(this.request).subscribe(result => {
      this.isLoading = false;
      this.otpResponse = JSON.parse(JSON.stringify(result));
      if(this.otpResponse.errMsg == '' || this.otpResponse.errMsg == null || this.otpResponse.errMsg == undefined) {
        console.log("========"+this.otpResponse.smsStatus);
        this.clearData();
        this.isShowOtp = true;
      }
    });
  }

  validateOtp(validateCustomerForm: NgForm, isValid) {
    if (!isValid) {
      this.showValidationMsgs = true;
      this.validateAllFields(this.validateCustomerForm.form);
    } else {
      this.isLoading = true;
      this.homeService.validateOTP(this.request).subscribe(result => {
        this.isLoading = false;
        this.otpResponse = JSON.parse(JSON.stringify(result));
        if(this.otpResponse.errMsg == '' || this.otpResponse.errMsg == null || this.otpResponse.errMsg == undefined) {
          this.router.navigate(['/UploadKyc'], { queryParams: { 'token': this.request.token } });
        } else {
          this.otpErrorMsg = this.otpResponse.errMsg;
          this.request.otp = "";
          this.isShowResendOtp = true;
          return;
        }
      });
    }
  }

  resendOTP() {
    this.generateOtp();
  }

  clearData() {
    this.otp = "";
    this.otpErrorMsg = "";
    this.isShowResendOtp = false;
  }

  redirectToErrorPage() {
    window.location.href = this.request.redirectURL;
  }
    
  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }
}